import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-quill/dist/quill.snow.css";
import "react-toastify/dist/ReactToastify.css";
import { registerLocale } from "react-datepicker";
import {
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Progress,
  Row,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";

import DropdownStatusNew from "components/Common/DropdownStatusNew";
import TextArea from "antd/es/input/TextArea";
import {
  COLOR_AUDITION_STATUS,
  COLOR_INQUIRY_STATUS,
  INQUIRY_STATUS,
  LIST_OPTION_AUDITION_STATUS,
} from "helpers/constans";
import { toast } from "react-toastify";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import inquiryListApi from "api/inquiryListApi";

export interface Props {
  id?: string;
  triggerRefresh?: () => void;
  setIsOpen?: any;
  setItemToEdit?: any;
}

registerLocale("en", en);
registerLocale("ko", ko);

const InquiryForm = ({
  id = "",
  triggerRefresh,
  setIsOpen,
  setItemToEdit,
}: Props) => {
  const { t, i18n } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingDetail, setIsLoadingDetail] = useState<boolean>(false);

  const handleSubmit = async (values: any) => {
    const data = values;

    try {
      setIsLoading((_prev) => true);
      const response: any = await inquiryListApi.updateInquiry(id, data);
      if (response?.data) {
        setIsLoading((_prev) => false);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        triggerRefresh && triggerRefresh();
      } else {
        setIsLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoading((_prev) => false);
      toast(`${error?.message || error || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const formik = useFormik({
    initialValues: {
      note: "",
      status: "",
    },
    onSubmit: handleSubmit,
  });

  const handleSetValueForm = (value: any) => {
    const data: any = {
      note: value?.note,
      status: value?.status,
    };

    formik.setValues(data);
  };

  const handleCallBarDetail = async (idItem: string) => {
    try {
      if (!idItem) {
        return;
      }
      setIsLoadingDetail((_prev) => true);
      const resDetail: any = await inquiryListApi.getInquiryDetail(idItem);
      if (resDetail?.data) {
        handleSetValueForm(resDetail?.data);
        setIsLoadingDetail((_prev) => false);
      }
    } catch (error: any) {
      setIsLoadingDetail((_prev) => false);
      return error;
    }
  };

  const onCloseClick = () => {
    setIsOpen(false);
    setItemToEdit(false);
  };

  useEffect(() => {
    handleCallBarDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    document.title = `${t("Inquiry Update")} - ${t("Inquiry")} | ShowStar`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <Modal isOpen={true} centered={true} scrollable={true} size="lg">
        <ModalHeader toggle={isLoading ? () => {} : onCloseClick}>
          {t("Update Inquiry")}
        </ModalHeader>
        <ModalBody className="pb-3 pt-0 px-4">
          {/* <div className="mb-4">
            <Progress
              value={
                100 - (100 / 2) * Number(Object.keys(formik.errors).length)
              }
              color="primary"
              className="animated-progress progress-sm"
            />
          </div> */}

          <div className="mt-3">
            <>
              {isLoadingDetail && (
                <div
                  style={{
                    position: "absolute",
                    zIndex: 3,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0,
                    backgroundColor: "rgb(164 164 164 / 36%)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spinner size="sm" color="primary"></Spinner>
                </div>
              )}
              <form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <Label className="form-label">{t("Status")}</Label>

                      <DropdownStatusNew
                        name="status"
                        dataList={INQUIRY_STATUS}
                        placeholder={`${t("Select status")}...`}
                        className="dropdown-status-rounded"
                        classNamePrefix="name-prefix"
                        initialValue={formik?.values?.status || null}
                        onChangeSelect={(event: any) =>
                          formik.setFieldValue("status", event?.value)
                        }
                        optionHide={!!id ? [] : ["CLOSED"]}
                        colors={COLOR_INQUIRY_STATUS}
                      />
                      {formik?.touched?.status && formik?.errors?.status ? (
                        <div className="text-danger mt-2">
                          {formik?.errors?.status}
                        </div>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="mb-3">
                      <Label className="form-label">{t("Note")} </Label>
                      <TextArea
                        id="name-bar"
                        name="title"
                        className="form-control"
                        placeholder={t("Enter the note")}
                        rows={6}
                        value={formik?.values?.note}
                        onChange={(event: any) =>
                          formik.setFieldValue("note", event?.target?.value)
                        }
                      />
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="hstack gap-2 justify-content-end">
                      <button type="submit" className="btn btn-primary fs-14">
                        {isLoading ? (
                          <Spinner size="sm" className="me-2"></Spinner>
                        ) : !!id ? (
                          <i className="ri-login-circle-line align-bottom me-2 "></i>
                        ) : (
                          <i className="ri-add-fill align-bottom me-2"></i>
                        )}
                        {t("Button Update")}
                      </button>
                    </div>
                  </Col>
                </Row>
              </form>
            </>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default InquiryForm;
